/**
 * Deals with quick menu items labels
 */
export class QuickMenuItems {
  /**
   * @constructor
   */
  constructor(
    // NOSONAR
    public menu: string = 'menu', // NOSONAR
    public addPoints: string[] = ['add-points', 'stars'], // NOSONAR
    public home: string[] = ['home', 'house'], // NOSONAR
    public rewards: string[] = ['rewards', 'local_activity'], // NOSONAR
    public coupons: string[] = ['coupons', 'redeem'], // NOSONAR
    public pointBalanceList: string[] = [
      'point-balance-list',
      'account_balance_wallet',
    ], // NOSONAR
    public printers: string[] = ['printers', 'print'], // NOSONAR
    public businessSettings: string[] = ['business-settings', 'domain'], // NOSONAR
    public accountSettings: string[] = ['account-settings', 'settings'], // NOSONAR
    public faq: string[] = ['faq', 'help'] // NOSONAR
  ) {}
}
